import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localtimeformat'
})
export class LocaltimeformatPipe implements PipeTransform {

  list:Array<string> = [
    "nada", "Enero","Febrero","Marzo","Abril","Mayo",
    "Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"
  ]
  transform(value:string):string{
    // console.log("time format pipe");
    // console.log("value: "+value);
    
    let objs =value.split(" ",2);
    let time = objs[1].split(":",3);
    let hour = Number(time[0]);
    let min = Number(time[1]);
    let date = objs[0].split("-",3);
    let day = Number(date[2]);
    let month = Number(date[1]);
    let year = Number(date[0]);
    // console.log("min "+min);
    // console.log("hour "+hour);
    // console.log("day "+day);
    // console.log("month: "+month);
    // console.log("year: "+year);
    let result:string = this.list[month];
    if(day<10)result = result+" 0"+day;
    else result = result+" "+day;
    result = result+" "+year+" ";
    if(hour<10)result = result+" 0"+hour;
    else result = result+" "+hour;
    if(min<10)result = result+":0"+min;
    else result = result+":"+min;

    return result;
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/pipes/localtimeformat.pipe.ts